import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dt__map"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dt__map-header" }
const _hoisted_4 = { class: "dt__map-header-title" }
const _hoisted_5 = { class: "block-titleSmall block-titleSmall_btnNavBack block-titleSmall_overflowText mb0" }
const _hoisted_6 = { class: "dt__map-header-nav" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dt-listIcon" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "К списку", -1 /* HOISTED */)
const _hoisted_9 = { class: "dt__map-map" }
const _hoisted_10 = { class: "dt__map-map-control" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dt-listIcon" }, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "К списку", -1 /* HOISTED */)
const _hoisted_13 = {
  class: "dt__map-dataContainer",
  ref: "jsContentPanel"
}
const _hoisted_14 = {
  key: 0,
  class: "dt__map-dataContainer dt__map-dataContainer_item jsItemsPanelEl",
  ref: "jsItemsPanel"
}
const _hoisted_15 = { class: "dt__map-dataContainer-head pt20" }
const _hoisted_16 = { class: "dt__map-dataContainer-head-count" }
const _hoisted_17 = { class: "dt__map-dataContainer-head-close" }
const _hoisted_18 = { class: "dt__map-dataContainer-content" }
const _hoisted_19 = { class: "dt__map-dataContainer-head pt20" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text skeleton-animation width50" }, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "dt__map-dataContainer-head-close" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "dt__map-dataContainer-content" }, " Идёт загрузка... ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_map_page = _resolveComponent("map-page")!
  const _component_map_page_list = _resolveComponent("map-page-list")!
  const _component_preview_card = _resolveComponent("preview-card")!
  const _component_skeleton_map = _resolveComponent("skeleton-map")!

  return (!this.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "block-btnNavBack",
                  to: $options.category.getUrl()
                }, null, 8 /* PROPS */, ["to"]),
                _createTextVNode(" " + _toDisplayString(this.category.name), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: $options.category.getUrl(),
                class: "dt__iconNav"
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_map_page, {
            onSelectIds: _cache[0] || (_cache[0] = (ids) => $options.onChoiceElem(ids)),
            objects: this.objects
          }, null, 8 /* PROPS */, ["objects"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: $options.category.getUrl(),
              class: "dt__iconNav"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_map_page_list, {
              category: $options.category,
              onOpenSearch: $options.onOpenSearchCategory
            }, null, 8 /* PROPS */, ["category", "onOpenSearch"])
          ], 512 /* NEED_PATCH */),
          (this.visibleCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!this.loadingItem)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, "Найдено: " + _toDisplayString(this.items.length), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.onHideItems && this.onHideItems(...args))),
                            class: "dt-closeIcon"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
                          return (_openBlock(), _createBlock(_component_preview_card, {
                            item: item,
                            "is-adaptive": true,
                            "page-identity": item.pageIdentity
                          }, null, 8 /* PROPS */, ["item", "page-identity"]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.visibleCard = !this.visibleCard)),
                            class: "dt-closeIcon"
                          })
                        ])
                      ]),
                      _hoisted_22
                    ], 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_skeleton_map, {
        key: 1,
        "visible-filter": false
      }))
}